import useColumns from './useColumns'
import useTabs from './useTabs'

export default { useColumns, useTabs }